export default __webpack_public_path__ + "static/media/300_1 1.8e4c001f.svg";